import Select from 'react-select';
import { observer, useLocalObservable } from 'mobx-react';
import { useEffect, useState } from 'react';

const CountryFilter = observer(
  ({
    currentUser,
    selectedCountryCode,
    showAllCwImpact,
    showUserImpact,
    filter,
  }) => {
    const localStore = useLocalObservable(() => ({
      countryFilterOptions: [],
      userCountryFilterOptions: [],
    }));

    const [selectedCountry, setSelectedCountry] = useState(null);

    useEffect(() => {
      setCountryFilterOptions();
    }, []);

    useEffect(() => {
      if (selectedCountryCode == '') {
        setSelectedCountry(null);
      }
    }, [selectedCountryCode]);

    const setCountryFilterOptions = () => {
      const countryUrl = '/api/v1/projects/impact_countries';

      if (showAllCwImpact) {
        getCountryFilterOptions(countryUrl, (options) => {
          localStore.countryFilterOptions = options;
        });
      }

      if (currentUser) {
        getCountryFilterOptions(
          `${countryUrl}?user_id=${currentUser.id}`,
          (options) => {
            localStore.userCountryFilterOptions = options;
          }
        );
      }
    };

    const getCountryFilterOptions = (countryUrl, callback) => {
      $.getJSON(countryUrl, (data) => {
        const options = [
          { value: 'all', label: 'All Countries' },
          ...data.countries.map((country) => ({
            value: country.code,
            label: country.name,
          })),
        ];

        callback(options);
      });
    };

    const handleCountryFilterChange = (selectedOption) => {
      setSelectedCountry(selectedOption);
      const newSelectedCountryCode =
        selectedOption.value === 'all' ? '' : selectedOption.value;

      filter(newSelectedCountryCode);
    };

    const countryFilterStyles = {
      indicatorSeparator: () => ({
        display: 'none',
      }),
      control: (base) => ({
        ...base,
        backgroundColor: '#fff',
        borderRadius: ' 9999px',
        width: '200px',
        height: '40px',
        fontFamily: 'Proxima Nova, sans-serif',
        fontSize: isMobile ? '0.7rem' : '0.8rem',
        color: '#333232',
        borderColor: 'transparent',
        boxShadow: 'none',
        '&:hover': {
          borderColor: 'transparent',
        },
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }),
      valueContainer: (base) => ({
        ...base,
        display: 'flex',
        alignItems: 'center',
        height: '40px',
        padding: '0 12px',
      }),
      placeholder: (base) => ({
        ...base,
        color: '#333232',
      }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? '#eee' : '#fff',
        color: '#333232',
        height: '40px',
        fontFamily: 'Proxima Nova, sans-serif',
        fontSize: isMobile ? '0.7rem' : '0.8rem',
        textAlign: 'left',
        width: '200px',
      }),
    };

    return (
      <Select
        classNamePrefix='country-filter-select'
        isSearchable={false}
        onChange={handleCountryFilterChange}
        options={
          showUserImpact
            ? localStore.userCountryFilterOptions
            : localStore.countryFilterOptions
        }
        placeholder='Explore by Country'
        styles={countryFilterStyles}
        value={selectedCountry}
      />
    );
  }
);

export default CountryFilter;
